var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.633 24 24 18.6325 24 12C24 5.36705 18.6325 0 12 0C5.36705 0 0 5.36752 0 12C0 18.633 5.36752 24 12 24ZM12 1.875C17.5965 1.875 22.125 6.40383 22.125 12C22.125 17.5965 17.5962 22.125 12 22.125C6.40345 22.125 1.875 17.5962 1.875 12C1.875 6.40345 6.40383 1.875 12 1.875ZM12 17.9589C12.5178 17.9589 12.9375 17.5391 12.9375 17.0214V10.9842C12.9375 10.4664 12.5178 10.0467 12 10.0467C11.4822 10.0467 11.0625 10.4664 11.0625 10.9842V17.0214C11.0625 17.5391 11.4822 17.9589 12 17.9589ZM10.7344 7.63306C10.7344 6.93407 11.301 6.36743 12 6.36743C12.699 6.36743 13.2656 6.93407 13.2656 7.63306C13.2656 8.33204 12.699 8.89868 12 8.89868C11.301 8.89868 10.7344 8.33204 10.7344 7.63306Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.ea453b9f71f6c800aa07f0aa162a132d.svg";
export { ForwardRef as ReactComponent };